import { Command } from '../Command';
import { JsonRange, PathUtils } from 'Editor/services/_Common/Selection';

export class UpdateEquationCommand extends Command {
  blockId: string;
  elementId: string;
  value: any;

  constructor(context: Editor.Edition.Context, blockId: string, elementId: string, value: any) {
    super(context);

    this.blockId = blockId;
    this.elementId = elementId;
    this.value = value;
  }

  async handleExec() {
    if (!this.context.DataManager) {
      throw new Error('Invalid DataManager or selection');
    }

    const baseModel = this.context.DataManager.nodes.getNodeModelById(this.blockId);

    if (baseModel) {
      let path = baseModel.findPathToChild(this.elementId);

      if (PathUtils.isValidSelectionPath(path)) {
        const startPosition: Editor.Selection.Position = {
          b: baseModel.id,
          p: [...path],
        };

        const childOffset = Number(path[path.length - 1]);

        if (!isNaN(childOffset)) {
          path[path.length - 1] = childOffset + 1;

          const endPosition: Editor.Selection.Position = {
            b: baseModel.id,
            p: [...path],
          };

          const jsonRange = new JsonRange(startPosition, endPosition);
          this.applySelection(jsonRange);

          if (this.context.commandFactory) {
            let command = this.context.commandFactory.getCommand('INSERT_EQUATION', this.value);
            await command?.exec();
          }
        }
      }
    }
  }
}
